<template>
  <v-dialog v-model="dialog" max-width="600" style="z-index:100000000;">
    <v-card>
      <div class="video-container">
        <video :key="videoSrc" autoplay controls>
          <source :src="videoSrc" type="video/mp4" />
        </video>
      </div>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="green darken-1" text @click="onClose">
          Stäng
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { roundToNearestMinutes } from 'date-fns/fp'
export default {
  name: 'IntroVideo',
  data() {
    return {
      dialog: roundToNearestMinutes,
      videoSrc:
        'https://havetstore.blob.core.windows.net/bilder/livet-pwa/livet_5.mp4'
    }
  },
  methods: {
    onClose() {
      this.$router.push({ name: 'Home' })
    }
  }
}
</script>

<style lang="scss" scoped>
.video-container {
  display: flex;
  justify-content: center;
  padding-top: 20px;
  padding-left: 20px;
  padding-right: 20px;
}
video {
  max-width: 100%;
  height: auto;
}
</style>
